module.exports = __webpack_public_path__ + "public/images/creative-writing.969f4e2ba29a222d928f57f62b4fe8a3.jpg";